import geoSpecificTextMapping from "./GeoSpecificTextMapping"

export default function getGeoSpecificText(geo) {
  if (!geo) {
    return false
  }

  const { geographicScale, locationName } = geo
  if (!geographicScale || !locationName) {
    return false
  }

  // Note: if we scale this experiment we will need to account for kebab-case
  const scale = geoSpecificTextMapping[geographicScale?.toLowerCase()]
  if (!scale) {
    return false
  }

  // set to false if the location is not one of the keys
  const textObj = scale[locationName?.toLowerCase()] || false

  return textObj
}
